export enum MenuItemKeys {
	View = 'view',
	Edit = 'edit',
	Delete = 'delete',
	Clone = 'clone',
	CreateAlerts = 'createAlerts',
}

export const MENUITEM_KEYS_VS_LABELS = {
	[MenuItemKeys.View]: 'View',
	[MenuItemKeys.Edit]: 'Edit',
	[MenuItemKeys.Delete]: 'Delete',
	[MenuItemKeys.Clone]: 'Clone',
	[MenuItemKeys.CreateAlerts]: 'Create Alerts',
};
